import { render, staticRenderFns } from "./SideGames.vue?vue&type=template&id=4e0457f9&lang=pug"
import script from "./SideGames.vue?vue&type=script&lang=ts"
export * from "./SideGames.vue?vue&type=script&lang=ts"
import style0 from "./SideGames.vue?vue&type=style&index=0&id=4e0457f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports